import script from "./select-sensor.vue?vue&type=script&lang=ts&setup=true"
export * from "./select-sensor.vue?vue&type=script&lang=ts&setup=true"

import "./select-sensor.vue?vue&type=style&index=0&id=7fc7fe06&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fc7fe06"]])

export default __exports__